// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"breadcrumbs-module--wrapper--L07P0","size_lg":"breadcrumbs-module--size_lg--2TWVk","size_sm":"breadcrumbs-module--size_sm--3FGPS"};